<div class="bloco-carteiras container-fluid" *ngIf="level !== 'Restrito'">
  <div class="cards-row">

    <ng-container *ngIf="!loading; else skeleton">
      <div class="card card-obras">
        <a routerLink="/obras/minha-carteira">
          <div class="card-header">
            <span class="card-icone card-icone--obras">
              <mat-icon aria-hidden="true">engineering</mat-icon>
            </span>
            <div class="card-title" title="Mostra a lista completa de todas as obras atribuídas a você.">
              Minhas Obras
            </div>
          </div>
          <span class="card-number">{{ myWorks }} obras</span>
          @if (myWorksUpdatedLast7Days > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ myWorksUpdatedLast7Days }} obra(s) atualizada(s) nos últimos 7 dias
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra atualizada nos últimos 7 dias
          </span>
          }
        </a>
      </div>

      @if (level === 'Master') {
      <div class="card card-obras">
        <a routerLink="/obras/carteira-equipe">
          <div class="card-header">
            <span class="card-icone card-icone--equipe">
              <mat-icon aria-hidden="true">groups</mat-icon>
            </span>
            <div class="card-title" title="Lista completa de todas as obras que estão sob responsabilidade da equipe.">
              Obras da Equipe
            </div>
          </div>
          <span class="card-number">{{ teamWorks }} obras</span>
          @if (teamWorksUpdatedLast7Days > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ teamWorksUpdatedLast7Days }} obra(s) atualizada(s) nos últimos 7 dias
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra atualizada nos últimos 7 dias
          </span>
          }
        </a>
      </div>
      }

      <div class="card card-obras">
        <a routerLink="/obras/nao-vistas">
          <div class="card-header">
            <span class="card-icone card-icone--nao-vistas">
              <mat-icon aria-hidden="true">visibility_off</mat-icon>
            </span>
            <div class="card-title" title="Lista das obras que estão sob sua responsabilidade e que ainda não foram acessadas.">
              Obras Ainda Não Vistas
            </div>
          </div>
          <span class="card-number">{{ notSeen }} obras</span>
          @if (notSeenAddedToday > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ notSeenAddedToday }} obra(s) adicionada(s) hoje
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra adicionada hoje
          </span>
          }
        </a>
      </div>

      <div class="card card-empresas">
        <a routerLink="/empresas/minha-carteira">
          <div class="card-header">
            <span class="card-icone card-icone--empresas">
              <mat-icon aria-hidden="true">business_center</mat-icon>
            </span>
            <div class="card-title" title="Lista das empresas que estão na sua carteira.">
              Empresas na Carteira
            </div>
          </div>
          
          @if (indicadores.companiesCount > 0) {
          <span class="card-number">{{ indicadores.companiesCount }} empresas</span>
          <!-- <span class="card-subtext card-subtext--empresas">
            <mat-icon class="info-icon-roxo">info</mat-icon>
            {{ indicadores.companiesCount }} empresa(s) na carteira
          </span> -->
          }@else {
          <span class="card-subtext card-subtext--empresas card-no-works">
            <mat-icon class="info-icon-roxo">info</mat-icon>
            Você não possui empresas salvas na carteira.
          </span>
          }
        </a>
      </div>
    </ng-container>

    <ng-template #skeleton>
      <div class="card skeleton-card"></div>
      @if (level === 'Master') {
      <div class="card skeleton-card"></div>
      }
      <div class="card skeleton-card"></div>
      <div class="card skeleton-card"></div>
    </ng-template>

  </div>
</div>